// extracted by mini-css-extract-plugin
export default {"form":"Stripe_form__FCyLp","info":"Stripe_info__WwUOk","cardElement":"Stripe_cardElement__4AGpt","pay_disabled":"Stripe_pay_disabled__rNu4z","pay_btn":"Stripe_pay_btn__XXqqG"};